export const FIO_ERROR_MESSAGE = 'Введите фамилию и имя через пробел';

export const validateFio = (value: string) => {
  const valueSplitted = String(value).split(' ');

  if (!(valueSplitted.length >= 2 && valueSplitted[0] && valueSplitted[1])) {
    return FIO_ERROR_MESSAGE;
  }

  return;
};
